/**
 * Общая 3-состоянийная сортировка таблиц Content Monitoring
 * (нейтрально → desc → asc → нейтрально).
 *
 * Компонент обязан иметь в data:
 *   sorts: {
 *     [tableKey]: { [field]: 0|1|2, type: field },
 *     ...
 *   }
 *
 * Методы:
 *   toggleSort(tableKey, field)
 *   classTableHead(tableKey, field) → '' | 'sort-by-bot down' | 'sort-by-bot up'
 *   sortRows(rows, tableKey, options?)
 *
 * options:
 *   fieldMap     — { sortField → rowProperty } (по умолчанию ключ = свойство строки)
 *   stringFields — поля, сравниваемые как строки
 *   stringValue  — (row, field, rowProperty) => string для кастомного текста
 */
export function createSortState(fields, defaultType = fields[0]) {
  const state = { type: defaultType };
  fields.forEach((field) => {
    state[field] = 0;
  });
  return state;
}

export default {
  methods: {
    toggleSort(tableKey, field) {
      const sortObj = this.sorts[tableKey];
      if (!sortObj) return;
      const current = sortObj[field] || 0;
      const next = { type: field };
      Object.keys(sortObj).forEach((key) => {
        if (key !== "type") next[key] = 0;
      });
      next[field] = (current + 1) % 3;
      this.$set(this.sorts, tableKey, next);
    },

    classTableHead(tableKey, field) {
      const sortObj = this.sorts[tableKey];
      if (!sortObj) return "";
      const status = sortObj[field];
      if (status === 1) return "sort-by-bot down";
      if (status === 2) return "sort-by-bot up";
      return "";
    },

    /**
     * @param {Array} rows
     * @param {string} tableKey
     * @param {{ fieldMap?: Object, stringFields?: string[], stringValue?: Function }} [options]
     */
    sortRows(rows, tableKey, options = {}) {
      if (!rows || !rows.length) return rows || [];
      const sortObj = this.sorts[tableKey];
      if (!sortObj) return rows;

      const field = sortObj.type;
      const dir = sortObj[field];
      if (!dir) return rows;

      const fieldMap = options.fieldMap || {};
      const stringFields = options.stringFields || [];
      const rowProp = fieldMap[field] || field;
      const isString = stringFields.includes(field);

      return [...rows].sort((rowA, rowB) => {
        if (isString) {
          const get =
            options.stringValue ||
            ((row, _f, prop) => (row[prop] || "").toString());
          const a = get(rowA, field, rowProp);
          const b = get(rowB, field, rowProp);
          const cmp = a.localeCompare(b, undefined, { sensitivity: "accent" });
          return dir === 1 ? -cmp : cmp;
        }

        // null/undefined = данных нет (напр. относит. TR у страницы без комментариев).
        // Проверяем ДО приведения: Number(null) === 0, и «нет данных» сортировалось бы
        // как настоящий ноль — по возрастанию такие строки лезли бы в начало списка.
        let a = rowA[rowProp] == null ? NaN : Number(rowA[rowProp]);
        let b = rowB[rowProp] == null ? NaN : Number(rowB[rowProp]);
        if (isNaN(a)) a = -Infinity;
        if (isNaN(b)) b = -Infinity;
        return dir === 1 ? b - a : a - b;
      });
    },
  },
};
